var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKonecranes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1549 1548",
    width: 1549,
    height: 1548,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff2301}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1274 780.9c-3.5 280.2-226 506.1-499.3 506.1-275.9 0-500.1-229.3-500.1-513 0-283.7 224.2-513 500.1-513v-260.4c-427.6 0-774.3 346.6-774.3 773.4 0 427.7 346.7 773.4 774.3 773.4 426 0 770.9-342.3 774.3-766.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonecranes);
export default __webpack_public_path__ + "static/media/konecranes.31274af60347826dabd4f278a5d138b8.svg";
export { ForwardRef as ReactComponent };